import { createAsyncThunk } from '@reduxjs/toolkit';
import EmployersApi from 'api/EmployersApi';
import { GetApplicationDataResponse } from 'handlers/applicationData';

export const createUpdatePayrollProviderToManualThunk = (api: EmployersApi) =>
  createAsyncThunk('applicationData/updatePayrollProviderToManual', async (applicationId: string, thunkApi) => {
    try {
      const response: GetApplicationDataResponse = await api.updatePayrollProviderToManual(applicationId);
      return response;
    } catch (error: unknown) {
      thunkApi.rejectWithValue(error);

      throw error;
    }
  });
